import Marquee from "react-fast-marquee";

const WORDS = [
  "Straight-Talking Coverage",
  "No Suits, No Slides",
  "Handshake, In Ink",
  "Protecting Your People",
];

export default function EditorialMarquee() {
  return (
    <section
      className="bg-cream border-y border-ink/10 py-10 md:py-14 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <Marquee speed={38} gradient={false} pauseOnHover>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-16 md:mx-24 flex items-center gap-16 md:gap-24">
            <span className="marquee-word text-ink text-6xl md:text-8xl lg:text-9xl leading-none whitespace-nowrap">
              {w}
            </span>
            <span className="text-gold text-4xl md:text-6xl font-serif leading-none">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
